<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeModal">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if (formLoaded) {
		<form (ngSubmit)="submit($event)" class="fade-in">
			<div class="modal-body">
				<div class="char-data__group">
					<rl-form-table-row [labelText]="'Name'" [required]="true"
						[class.has-error]="form.controls.templateLabel.errors && form.controls.templateLabel.touched">
						<ng-template rlFormTableControl>
							<rl-text-input [(formControl)]="form.controls.templateLabel"
								[dataLabel]="'templatelabelInput'"></rl-text-input>
						</ng-template>
						@if (form.controls.templateLabel.errors?.required && form.controls.templateLabel.touched) {
							<ng-template rlFormTableMessage>
								Name is required.
							</ng-template>
						}
						@if (form.controls.templateLabel.errors?.draftTemplateLabelDuplicate && form.controls.templateLabel.touched) {
							<ng-template rlFormTableMessage>
								Duplicate Draft Template Name is not allowed.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'File'">
						<ng-template rlFormTableControl>
							<div class="d-flex align-items-center">
								<div class="flex-grow-1">
									{{ form.controls.filePath.value }}
									@if (form.controls.filePath.value) {
										<button type="button" class="btn btn-icon btn-remove btn-sm"
											(click)="removeFile()" data-cy="removeAttachment"><i
												class="fal fa-xmark fa-sm" title="Remove Attachment"></i></button>
									}
								</div>
								<button type="button" class="btn btn-sm btn-link" (click)="chooseFile($event)"
									data-cy="ChooseFileButton"><i class="fal fa-arrow-up-to-line"></i>
									Choose File</button>
							</div>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Available on selected Templates'">
						<ng-template rlFormTableControl>
							<div class="scroll-vert border-top py-2 padding-left-1px">
								@for (template of templates; track template; let i = $index) {
									<div class="char-data-element-display">
										<label class="py-1">
											<input type="checkbox" [value]="template.templateID"
												class="form-check-input me-2"
												[checked]="isTemplateIdChecked(template.templateID)"
												(change)="onSelectedTemplateIdsChange(template.templateID, $event.target.checked)"
												[attr.data-cy]="'checkboxInputAvailableTemplate' + template.templateName | trimWhitespace" />
											{{
                        template.templateName }}
										</label>
									</div>
								}
							</div>
						</ng-template>
					</rl-form-table-row>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="closeButton">Cancel</button>
				<button type="submit" class="btn btn-success" [disabled]="form.invalid || isSaving"
					data-cy="saveButton">Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="2"></rl-form-placeholder>
		</div>
	}
</div>